<template>
  <v-card :key="mode">
    <v-card-text v-if="object">
      <v-card class="mb-2">
        <v-card-title>
          Relevamiento
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-text-field
              disabled
              v-model="object.producer_name"
              label="Productor"
            >
              <v-icon
                slot="append-outer"
                class="enabled-icon"
                v-show="editing && (object.survey ? false : true)"
                @click="producerClick"
                >mdi-magnify
              </v-icon>
            </v-text-field>
          </div>
          <div class="d-flex align-center">
            <v-text-field
              disabled
              v-model="object.commercial_person_name"
              label="Agente"
            >
              <v-icon
                slot="append-outer"
                class="enabled-icon"
                v-show="
                  editing &&
                    (object.survey ? false : true) &&
                    current_level <= 2
                "
                @click="commercialPersonClick"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </div>
          <div class="d-flex align-center">
            <v-text-field
              disabled
              v-model="object.territory_description"
              label="Territorio"
            >
              <v-icon
                slot="append-outer"
                class="enabled-icon"
                v-show="editing && canEditTerritory"
                @click="territoryClick"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </div>
        </v-card-text>
      </v-card>

      <!-- datos de contacto -->
      <v-card class="mb-2">
        <v-card-title>
          Datos de Contacto (Producción)
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Nombre"
            id="contact_name"
            v-model="object.contact_name"
            :disabled="!editing"
          ></v-text-field>
          <v-text-field
            label="email"
            id="contact_email"
            v-model="object.contact_email"
            :disabled="!editing"
            @input="
              v => {
                object.contact_email = v.toLowerCase();
              }
            "
          ></v-text-field>
          <v-text-field
            label="Teléfono"
            id="contact_phone"
            v-model="object.contact_phone"
            :disabled="!editing"
            type="number"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="showProducer || showTerritory || showCommercialPerson"
      :show="showProducer || showTerritory || showCommercialPerson"
      :title="searchOptions.title"
      :endpoint="searchOptions.endpoint"
      :ordering="searchOptions.ordeting"
      :searchLabel="searchOptions.searchLabel"
      :headers="searchOptions.headers"
      :filterString="searchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import DataSurvey from "@/components/clon/DataSurvey.js";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "SurveyEdit",

  components: {
    PaginatedSearchDialog
  },

  props: ["value", "initialmode"],

  data() {
    return {
      object: null,
      current_level: null,
      editing: false,
      mode: null,
      survey: new DataSurvey(this.$bRoot),
      searchOptions: null,
      showProducer: false,
      showTerritory: false,
      showCommercialPerson: false,
      canEditTerritory: false
    };
  },

  methods: {
    producerClick() {
      //add producer
      this.searchOptions = {
        headers: [
          { text: "Nombre", value: "name", sortable: false },
          { text: "CUIT", value: "identification", sortable: false },
          { text: "Tipo", value: "category_description", sortable: false }
        ],
        title: "Productor",
        endpoint: "/data/producers",
        ordering: "name",
        searchLabel: "Nombre/CUIT",
        filterString: null
      };
      this.showProducer = true;
    },

    commercialPersonClick() {
      this.searchOptions = {
        headers: [
          { text: "Nombre", value: "name", sortable: false },
          // eslint-disable-next-line
          { text: "Identificación Tipo", value: "identification_type_code", sortable: false },
          { text: "Identificación", value: "identification", sortable: false },
          // eslint-disable-next-line
          { text: "Tipo", value: "commercial_type_description", sortable: false }
        ],
        title: "Agente",
        endpoint: "/data/commercial_persons_hierarchy",
        ordering: "name",
        searchLabel: "Nombre/CUIT",
        filterString: "commercial_type_level=3"
      };
      this.showCommercialPerson = true;
    },

    territoryClick() {
      //add territory
      this.searchOptions = {
        headers: [
          { text: "Territorio", value: "description", sortable: false },
          { text: "Tipo", value: "description_type", sortable: false }
        ],
        title: "Territorio",
        endpoint: "/data/territories_hierarchy",
        ordering: "level,description",
        searchLabel: "Localidad,Departamento,Provincia",
        filterString: this.current_level <= 2 ? null : "level__gte=2"
      };
      this.showTerritory = true;
    },

    searchSelected(data) {
      if (this.showProducer) {
        this.producerSelected(data);
      } else if (this.showTerritory) {
        this.territorySelected(data);
      } else if (this.showCommercialPerson) {
        this.commercialPersonSelected(data);
      }
    },

    producerSelected(data) {
      this.showProducer = false;
      this.searchOptions = {};
      this.object.producer = data.url;
      this.object.producer_id = data.id;
      this.object.producer_name = data.name;
      this.object.producer_identification = data.identification;
      this.onPkDataChange();
    },

    commercialPersonSelected(data) {
      this.showCommercialPerson = false;
      this.searchOptions = {};
      this.object.commercial_person = data.commercial_person;
      this.object.commercial_person_id = data.commercial_id;
      this.object.commercial_person_name = data.name;
      this.object.commercial_person_type_description =
        data.commercial_type_description;
      this.object.commercial_person_assigned = null;
      this.onPkDataChange();
    },

    territorySelected(data) {
      this.showTerritory = false;
      this.searchOptions = {};
      this.object.territory_id = data.id;
      this.object.territory = data.territory;
      this.object.territory_description = data.description;
      this.object.territory_type_description = data.description_type;
      this.object.territory_level = data.level;
      this.onPkDataChange();
    },

    searchCanceled() {
      this.showProducer = false;
      this.showTerritory = false;
      this.showCommercialPerson = false;
      this.searchOptions = {};
    },

    async onPkDataChange() {
      let filterstring = "";
      let response = null;

      if (
        this.mode !== "show" &&
        this.object.territory &&
        this.object.producer &&
        this.object.commercial_person
      ) {
        //survey_hierarchy
        filterstring =
          // eslint-disable-next-line
          "producer_id=" + this.object.producer_id.toString() +
          // eslint-disable-next-line
          "&territory_id=" + this.object.territory_id.toString() +
          // eslint-disable-next-line
          "&commercial_person_id=" + this.object.commercial_person_id.toString()
        response = await this.survey.search(filterstring, false, 1);
        if (response.data.results.length > 0) {
          this.object = response.data.results[0];
          this.object.url = this.object.survey;
          this.mode = "show";
        } else {
          if (this.object.territory_level !== 3) {
            this.state = "new";
          } else {
            //surveys
            // eslint-disable-next-line
            filterstring = "producer__id=" + this.object.producer_id.toString() + "&territory__id=" + this.object.territory_id.toString()
            response = await this.survey.search(filterstring, true, 1);
            if (response.data.results.length > 0) {
              this.$bRoot.setError("El registro ya existe");
              this.$emit("endEdit");
            } else {
              this.mode = "new";
            }
          }
        }
      }
    },
    async save() {
      let added = null;
      try {
        added = await this.survey.save(this.object);
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        if (added) {
          this.object.url = added.url;
          this.object.survey = added.url;
          this.object.survey_id = added.id;
          this.mode = "show";
          this.editing = false;
          this.$emit("endEdit", this.object);
        }
      }
    }
  },

  mounted() {
    this.object = this.value;
    this.object.url = this.object.survey;
    this.current_level = this.$bRoot.auth.current_level;

    this.survey.canEditTerritory(this.object).then(result => {
      this.canEditTerritory = result;
      this.mode = this.initialmode;
      this.editing = this.mode === "edit" || this.mode == "new";
      if (!this.object.url) {
        this.onPkDataChange();
      }
    });
  }
};
</script>
<style scoped>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
